/**
 * Prose-block content reveal DOM contract (see docs/04-motion.md).
 *
 * Server components opt pin / headline / prose / aside / actions into the
 * shared GSAP play-once timeline via the props below. The `ProseBlockReveal`
 * island queries *within its root* so multiple blocks never steal targets.
 */

/** Marks the play-once reveal root (also the ScrollTrigger trigger). */
export const PROSE_BLOCK_REVEAL_ATTR = 'data-prose-block-reveal';

export const PROSE_BLOCK_REVEAL_SELECTOR = `[${PROSE_BLOCK_REVEAL_ATTR}]`;

/** Spread onto the island root (applied by `ProseBlockReveal`). */
export const PROSE_BLOCK_REVEAL_PROPS = { [PROSE_BLOCK_REVEAL_ATTR]: '' } as const;

/** Marks the location-pin wrapper for GSAP scale/fade with the headline. */
export const PROSE_BLOCK_PIN_ATTR = 'data-prose-block-pin';

export const PROSE_BLOCK_PIN_SELECTOR = `[${PROSE_BLOCK_PIN_ATTR}]`;

/** Spread onto the pin appear target. */
export const PROSE_BLOCK_PIN_PROPS = { [PROSE_BLOCK_PIN_ATTR]: '' } as const;

/** Marks the headline for the localized SplitText reveal. */
export const PROSE_BLOCK_HEADLINE_ATTR = 'data-prose-block-headline';

export const PROSE_BLOCK_HEADLINE_SELECTOR = `[${PROSE_BLOCK_HEADLINE_ATTR}]`;

/** Spread onto the headline element targeted by SplitText. */
export const PROSE_BLOCK_HEADLINE_PROPS = { [PROSE_BLOCK_HEADLINE_ATTR]: '' } as const;

/** Marks the prose wrapper for the post-headline fade. */
export const PROSE_BLOCK_PROSE_ATTR = 'data-prose-block-prose';

export const PROSE_BLOCK_PROSE_SELECTOR = `[${PROSE_BLOCK_PROSE_ATTR}]`;

/** Spread onto the prose fade root. */
export const PROSE_BLOCK_PROSE_PROPS = { [PROSE_BLOCK_PROSE_ATTR]: '' } as const;

/**
 * Marks an optional aside / bubble (e.g. threatened StatCircle) — fades +
 * subtle scale with the headline segment (GSAP owns the appear; skip
 * `<StatCircleReveal>` motion when wrapping).
 */
export const PROSE_BLOCK_ASIDE_ATTR = 'data-prose-block-aside';

export const PROSE_BLOCK_ASIDE_SELECTOR = `[${PROSE_BLOCK_ASIDE_ATTR}]`;

/** Spread onto the aside reveal root. */
export const PROSE_BLOCK_ASIDE_PROPS = { [PROSE_BLOCK_ASIDE_ATTR]: '' } as const;

/**
 * Marks optional CTA buttons — each element staggers after the prose fade.
 */
export const PROSE_BLOCK_ACTION_ATTR = 'data-prose-block-action';

export const PROSE_BLOCK_ACTION_SELECTOR = `[${PROSE_BLOCK_ACTION_ATTR}]`;

/** Spread onto each action / CTA element. */
export const PROSE_BLOCK_ACTION_PROPS = { [PROSE_BLOCK_ACTION_ATTR]: '' } as const;
